enum EnumRecurrenceType {
    OneTime,
    Daily,
    WeekDay,
    Weekly,
    Monthly,
    Yearly
}

export { EnumRecurrenceType };
